module.exports = __webpack_public_path__ + "static/media/stake-hint.45c1dac6.svg";